import V, { forwardRef as ae, useState as Q, useMemo as jt, Fragment as ce } from "react";
import { m as N, M as at, v as le, f as se, au as ue, S as fe, af as de, ax as Ot, ay as _, ag as Ct, aa as xt, o as pe, z as y } from "./index2.js";
import { l as ge } from "./index6.js";
import { b as he } from "./Transition.js";
function St(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function A(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? St(Object(n), !0).forEach(function(o) {
      c(t, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : St(Object(n)).forEach(function(o) {
      Object.defineProperty(t, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return t;
}
function me(t) {
  var e = function(n, o) {
    if (typeof n != "object" || !n)
      return n;
    var i = n[Symbol.toPrimitive];
    if (i !== void 0) {
      var l = i.call(n, o);
      if (typeof l != "object")
        return l;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(n);
  }(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function c(t, e, n) {
  return (e = me(e)) in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function ct() {
  return ct = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, ct.apply(this, arguments);
}
function Dt(t, e) {
  if (t == null)
    return {};
  var n, o, i = function(p, d) {
    if (p == null)
      return {};
    var s, f, u = {}, v = Object.keys(p);
    for (f = 0; f < v.length; f++)
      s = v[f], d.indexOf(s) >= 0 || (u[s] = p[s]);
    return u;
  }(t, e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(t);
    for (o = 0; o < l.length; o++)
      n = l[o], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (i[n] = t[n]);
  }
  return i;
}
function Y(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, { raw: { value: Object.freeze(e) } }));
}
function tt(t, e) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(t) || function(n, o) {
    var i = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (i != null) {
      var l, p, d, s, f = [], u = !0, v = !1;
      try {
        if (d = (i = i.call(n)).next, o !== 0)
          for (; !(u = (l = d.call(i)).done) && (f.push(l.value), f.length !== o); u = !0)
            ;
      } catch (O) {
        v = !0, p = O;
      } finally {
        try {
          if (!u && i.return != null && (s = i.return(), Object(s) !== s))
            return;
        } finally {
          if (v)
            throw p;
        }
      }
      return f;
    }
  }(t, e) || At(t, e) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Ht(t) {
  return function(e) {
    if (Array.isArray(e))
      return lt(e);
  }(t) || function(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
      return Array.from(e);
  }(t) || At(t) || function() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function At(t, e) {
  if (t) {
    if (typeof t == "string")
      return lt(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? lt(t, e) : void 0;
  }
}
function lt(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, o = new Array(e); n < e; n++)
    o[n] = t[n];
  return o;
}
var r = { Top: "top", Bottom: "bottom", Left: "left", Right: "right", CenterVertical: "center-vertical", CenterHorizontal: "center-horizontal" }, a = { Start: "start", Middle: "middle", End: "end", Fit: "fit" };
function ve(t) {
  var e = t.useRelativePositioning, n = t.spacing, o = t.align, i = t.justify, l = t.referenceElViewportPos, p = l === void 0 ? I : l, d = t.referenceElDocumentPos, s = d === void 0 ? I : d, f = t.contentElViewportPos, u = f === void 0 ? I : f, v = t.contentElDocumentPos, O = v === void 0 ? I : v, b = t.scrollContainer, F = t.windowHeight, z = F === void 0 ? window.innerHeight : F, W = t.windowWidth, q = W === void 0 ? window.innerWidth : W, M = b ? b.offsetWidth : q, G = b ? b.offsetHeight : z, J = { windowWidth: M, windowHeight: G, referenceElViewportPos: p, contentElViewportPos: u, spacing: n }, S = function(m, g) {
    var h = g.spacing, C = g.windowWidth, x = g.windowHeight, E = g.contentElViewportPos, D = g.referenceElViewportPos, L = [m].concat(Ht(Oe[m]));
    return L.find(function(P) {
      return [r.Top, r.Bottom, r.CenterVertical].includes(P) ? Vt({ top: st({ align: P, contentElPos: E, referenceElPos: D, spacing: h }), windowHeight: x, contentHeight: E.height }) : !![r.Left, r.Right, r.CenterHorizontal].includes(P) && Tt({ left: ut({ align: P, contentElPos: E, referenceElPos: D, spacing: h }), windowWidth: C, contentWidth: E.width });
    }) || m;
  }(o, J), B = function(m, g, h) {
    var C, x, E = h.spacing, D = h.windowWidth, L = h.windowHeight, P = h.contentElViewportPos, w = h.referenceElViewportPos, K = [m].concat(Ht(it[m]));
    switch (g) {
      case r.Top:
      case r.Bottom:
      case r.CenterVertical:
        return (C = K.find(function(T) {
          return Tt({ contentWidth: T === a.Fit ? w.width : P.width, windowWidth: D, left: ut({ contentElPos: P, referenceElPos: w, spacing: E, align: g, justify: T }) });
        })) !== null && C !== void 0 ? C : it[m][0];
      case r.Left:
      case r.Right:
      case r.CenterHorizontal:
        return (x = K.find(function(T) {
          return Vt({ contentHeight: T === a.Fit ? w.height : P.height, windowHeight: L, top: st({ contentElPos: P, referenceElPos: w, spacing: E, align: g, justify: T }) });
        })) !== null && x !== void 0 ? x : it[m][0];
    }
  }(i, S, J), k = function(m) {
    var g, h, C = m.align, x = m.justify, E = Ee[C], D = (g = E.x) !== null && g !== void 0 ? g : ye[x], L = (h = E.y) !== null && h !== void 0 ? h : we[x];
    return "".concat(D, " ").concat(L);
  }({ align: S, justify: B }), U = function(m, g) {
    var h = 0.8;
    switch (m) {
      case r.Top:
        return "translate3d(0, ".concat(g, "px, 0) scale(").concat(h, ")");
      case r.Bottom:
        return "translate3d(0, -".concat(g, "px, 0) scale(").concat(h, ")");
      case r.Left:
        return "translate3d(".concat(g, "px, 0, 0) scale(").concat(h, ")");
      case r.Right:
        return "translate3d(-".concat(g, "px, 0, 0) scale(").concat(h, ")");
      case r.CenterHorizontal:
      case r.CenterVertical:
        return "scale(".concat(h, ")");
    }
  }(S, n);
  return Math.floor(u.width) === 0 && i !== a.Fit ? { align: o, justify: i, positionCSS: { left: 0, top: 0, transform: U, transformOrigin: k } } : e ? { align: S, justify: B, positionCSS: A(A({}, Pe({ align: S, justify: B, referenceElDocumentPos: s, contentElDocumentPos: O, spacing: n })), {}, { transformOrigin: k, transform: U }) } : { align: S, justify: B, positionCSS: A(A({}, je({ align: S, justify: B, referenceElDocumentPos: s, contentElDocumentPos: O, spacing: n, windowHeight: G, windowWidth: M })), {}, { transformOrigin: k, transform: U }) };
}
var I = { top: 0, bottom: 0, left: 0, right: 0, height: 0, width: 0 }, It = function(t, e) {
  var n = t.getBoundingClientRect(), o = n.top, i = n.bottom, l = n.left, p = n.right, d = n.width;
  return { top: o, bottom: i, left: l, right: p, height: t.offsetHeight, width: e ? d : parseFloat(getComputedStyle(t).width) };
};
function Rt(t, e, n) {
  if (!t)
    return I;
  var o = It(t, n), i = o.top, l = o.bottom, p = o.left, d = o.right, s = o.height, f = o.width;
  if (e) {
    var u = e.scrollTop, v = e.scrollLeft, O = e.getBoundingClientRect();
    return { top: i + u - O.top, bottom: l + u - O.bottom, left: p + v - O.left, right: d + v - O.right, height: s, width: f };
  }
  var b = window, F = b.scrollX, z = b.scrollY;
  return { top: i + z, bottom: l + z, left: p + F, right: d + F, height: s, width: f };
}
function Mt(t, e, n) {
  if (!t)
    return I;
  var o = It(t, n), i = o.top, l = o.bottom, p = o.left, d = o.right, s = o.height, f = o.width;
  if (e) {
    var u = e.getBoundingClientRect();
    return { top: i - u.top, bottom: l - u.bottom, left: p - u.left, right: d - u.right, height: s, width: f };
  }
  return { top: i, bottom: l, left: p, right: d, height: s, width: f };
}
var we = c(c(c(c({}, a.Start, "top"), a.Middle, "center"), a.End, "bottom"), a.Fit, "center"), ye = c(c(c(c({}, a.Start, "left"), a.Middle, "center"), a.End, "right"), a.Fit, "center"), Ee = c(c(c(c(c(c({}, r.Left, { x: "right" }), r.Right, { x: "left" }), r.Top, { y: "bottom" }), r.Bottom, { y: "top" }), r.CenterHorizontal, { x: "center" }), r.CenterVertical, { y: "center" }), ot = c(c(c(c({}, a.Start, { top: 0 }), a.End, { bottom: 0 }), a.Middle, function(t) {
  var e = t.contentElDocumentPos, n = t.referenceElDocumentPos;
  return { top: "".concat(n.height / 2 - e.height / 2, "px") };
}), a.Fit, { top: 0, bottom: 0 }), rt = c(c(c(c({}, a.Start, { left: 0 }), a.End, { right: 0 }), a.Middle, function(t) {
  var e = t.contentElDocumentPos, n = t.referenceElDocumentPos;
  return { left: "".concat(n.width / 2 - e.width / 2, "px") };
}), a.Fit, { left: 0, right: 0 }), be = c(c(c(c(c(c({}, r.Top, { constant: function(t) {
  var e = t.spacing;
  return { bottom: "calc(100% + ".concat(e, "px)") };
}, justifyPositions: rt }), r.Bottom, { constant: function(t) {
  var e = t.spacing;
  return { top: "calc(100% + ".concat(e, "px)") };
}, justifyPositions: rt }), r.CenterVertical, { constant: function(t) {
  var e = t.referenceElDocumentPos;
  return { top: "calc(".concat(e.height / 2, "px - 50%)") };
}, justifyPositions: rt }), r.Left, { constant: function(t) {
  var e = t.spacing;
  return { right: "calc(100% + ".concat(e, "px)") };
}, justifyPositions: ot }), r.Right, { constant: function(t) {
  var e = t.spacing;
  return { left: "calc(100% + ".concat(e, "px)") };
}, justifyPositions: ot }), r.CenterHorizontal, { constant: function(t) {
  var e = t.referenceElDocumentPos;
  return { left: "calc(".concat(e.width / 2, "px - 50%)") };
}, justifyPositions: ot });
function Pe(t) {
  var e, n = t.align, o = t.justify, i = t.referenceElDocumentPos, l = t.contentElDocumentPos, p = t.spacing, d = be[n], s = d.justifyPositions[o], f = { contentElDocumentPos: l, referenceElDocumentPos: i, spacing: p };
  return A(A({}, (e = d.constant) === null || e === void 0 ? void 0 : e.call(d, f)), typeof s == "function" ? s(f) : s);
}
function je(t) {
  var e = t.align, n = t.justify, o = t.referenceElDocumentPos, i = t.contentElDocumentPos, l = t.spacing, p = t.windowWidth, d = t.windowHeight, s = ut({ align: e, justify: n, referenceElPos: o, contentElPos: i, spacing: l }), f = "".concat(s, "px"), u = "".concat(st({ align: e, justify: n, referenceElPos: o, contentElPos: i, spacing: l }), "px");
  return n !== a.Fit ? { left: f, top: u } : [r.Left, r.Right, r.CenterHorizontal].includes(e) ? { left: f, top: u, bottom: "".concat(d - o.bottom, "px") } : { left: f, top: u, right: "".concat(p - (s + o.width), "px") };
}
function st(t) {
  var e = t.align, n = t.justify, o = t.contentElPos, i = t.referenceElPos, l = t.spacing;
  switch (e) {
    case r.Left:
    case r.Right:
    case r.CenterHorizontal:
      switch (n) {
        case a.Start:
        case a.Fit:
          return i.top;
        case a.End:
          return i.top + i.height - o.height;
        case a.Middle:
        default:
          return i.top - (o.height - i.height) / 2;
      }
    case r.CenterVertical:
      return i.top - (o.height - i.height) / 2;
    case r.Top:
      return i.top - o.height - l;
    case r.Bottom:
    default:
      return i.top + i.height + l;
  }
}
function ut(t) {
  var e = t.align, n = t.justify, o = t.contentElPos, i = t.referenceElPos, l = t.spacing;
  switch (e) {
    case r.Top:
    case r.Bottom:
    case r.CenterVertical:
      switch (n) {
        case a.End:
          return i.left + i.width - o.width;
        case a.Middle:
          return i.left - (o.width - i.width) / 2;
        case a.Start:
        case a.Fit:
        default:
          return i.left;
      }
    case r.Left:
      return i.left - o.width - l;
    case r.Right:
      return i.left + i.width + l;
    case r.CenterHorizontal:
    default:
      return i.left - (o.width - i.width) / 2;
  }
}
function Tt(t) {
  var e = t.left, n = t.windowWidth, o = t.contentWidth;
  return e >= 0 && !(e + o > n);
}
function Vt(t) {
  var e = t.top, n = t.windowHeight, o = t.contentHeight;
  return e >= 0 && !(e + o > n);
}
var Oe = c(c(c(c(c(c({}, r.Top, [r.Bottom]), r.Bottom, [r.Top]), r.Left, [r.Right]), r.Right, [r.Left]), r.CenterHorizontal, [r.Left, r.Right]), r.CenterVertical, [r.Top, r.Bottom]), it = c(c(c(c({}, a.Start, [a.End, a.Middle]), a.Middle, [a.End, a.Start]), a.End, [a.Start, a.Middle]), a.Fit, [a.Middle, a.Start, a.End]), Ft, zt, Bt, Lt, Nt, Ce = ["active", "spacing", "align", "justify", "adjustOnMutation", "children", "className", "popoverZIndex", "refEl", "usePortal", "portalClassName", "portalContainer", "portalRef", "scrollContainer", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited"], xe = ["transform"], Se = N(Ft || (Ft = Y([`
  position: absolute;
  transition: transform `, `ms ease-in-out,
    opacity `, `ms ease-in-out;
  opacity: 0;
`])), at.default, at.default), Wt = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, De = le("popover-content"), $t = ae(function(t, e) {
  var n, o = t.active, i = o !== void 0 && o, l = t.spacing, p = l === void 0 ? 10 : l, d = t.align, s = d === void 0 ? r.Bottom : d, f = t.justify, u = f === void 0 ? a.Start : f, v = t.adjustOnMutation, O = v !== void 0 && v, b = t.children, F = t.className, z = t.popoverZIndex, W = t.refEl, q = t.usePortal, M = q === void 0 || q, G = t.portalClassName, J = t.portalContainer, S = t.portalRef, B = t.scrollContainer, k = t.onEnter, U = t.onEntering, m = t.onEntered, g = t.onExit, h = t.onExiting, C = t.onExited, x = Dt(t, Ce), E = tt(Q(null), 2), D = E[0], L = E[1], P = tt(Q(null), 2), w = P[0], K = P[1], T = tt(Q(0), 2), ft = T[0], kt = T[1], dt = se().setIsPopoverOpen, pt = ue(), Z = pt.portalContainer, H = pt.scrollContainer;
  Z = J || Z, H = B || H, M && H && (H.contains(Z) || fe.warn("To ensure correct positioning make sure that the portalContainer element is inside of the scrollContainer"));
  var gt = V.useRef(w);
  gt.current = w;
  var $ = null;
  if (W && W.current)
    $ = W.current;
  else if (D) {
    var et = D.parentNode;
    et && et instanceof HTMLElement && ($ = et);
  }
  var ht = de(), mt = O && i, Ut = Ot($, Wt, Date.now, mt), Zt = Ot(w == null ? void 0 : w.parentNode, Wt, Date.now, mt), Xt = _(Mt($, H, !0)), Yt = _(Mt(w == null ? void 0 : w.parentNode, H)), vt = _(jt(function() {
    return Rt($, H, !0);
  }, [$, H, ht, Ut, i, s, u, ft])), qt = _(jt(function() {
    return Rt(w);
  }, [w == null ? void 0 : w.parentNode, ht, Zt, i, s, u, ft])), wt = Ct(u), Gt = Ct(s), yt = wt !== u && (u === a.Fit || wt === a.Fit) || Gt !== s && u === a.Fit;
  xt(function() {
    yt && kt(function(j) {
      return j + 1;
    });
  }, [yt]);
  var Et = tt(Q(!1), 2), Jt = Et[0], Kt = Et[1];
  if (xt(function() {
    return Kt(!0);
  }, []), !Jt)
    return null;
  var bt, nt = ve({ useRelativePositioning: !M, spacing: p, align: s, justify: u, referenceElViewportPos: Xt, referenceElDocumentPos: vt, contentElViewportPos: Yt, contentElDocumentPos: qt, scrollContainer: H }), Qt = nt.align, _t = nt.justify, Pt = nt.positionCSS, te = Pt.transform, ee = Dt(Pt, xe), ne = N(zt || (zt = Y([`
      opacity: 1;
      position: `, `;
      pointer-events: initial;
    `])), M ? "" : "absolute"), oe = M ? ge : ce, re = { className: Z ? void 0 : G, container: (n = Z) !== null && n !== void 0 ? n : void 0, portalRef: S }, ie = M ? re : {};
  return bt = b == null ? null : typeof b == "function" ? b({ align: Qt, justify: _t, referenceElPos: vt }) : b, V.createElement(he, { nodeRef: gt, in: i, timeout: at.default, mountOnEnter: !0, unmountOnExit: !0, appear: !0, onEntering: U, onEnter: k, onEntered: function() {
    dt(!0);
    for (var j = arguments.length, X = new Array(j), R = 0; R < j; R++)
      X[R] = arguments[R];
    m == null || m.apply(void 0, X);
  }, onExiting: h, onExit: g, onExited: function() {
    dt(!1);
    for (var j = arguments.length, X = new Array(j), R = 0; R < j; R++)
      X[R] = arguments[R];
    C == null || C.apply(void 0, X);
  } }, function(j) {
    return V.createElement(V.Fragment, null, V.createElement("span", { ref: L, className: N(Bt || (Bt = Y([`
                display: none;
              `]))) }), V.createElement(oe, ie, V.createElement("div", ct({}, x, { ref: e, className: pe(Se, N(ee), c(c(c({}, N({ transform: te }), j === "entering" || j === "exiting"), ne, j === "entered"), N(Lt || (Lt = Y([`
                      z-index: `, `;
                    `])), z), typeof z == "number"), F, c({}, N(Nt || (Nt = Y([`
                      transition-delay: 0ms;
                    `]))), j === "exiting")) }), V.createElement("div", { ref: K, className: De }, bt))));
  });
});
$t.displayName = "Popover", $t.propTypes = { children: y.oneOfType([y.node, y.func]), active: y.bool, className: y.string, align: y.oneOf(Object.values(r)), justify: y.oneOf(Object.values(a)), refEl: y.shape({ current: typeof window < "u" ? y.instanceOf(Element) : y.any }), usePortal: y.bool, portalClassName: y.string, spacing: y.number, adjustOnMutation: y.bool };
export {
  r as T,
  a as V,
  $t as l
};
